import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/logos/title.jpg';
const _withScopeId = (n) => (_pushScopeId("data-v-10994bc5"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "menu" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    alt: "default",
    src: _imports_0
}, null, -1));
const _hoisted_3 = [
    _hoisted_2
];
const _hoisted_4 = {
    class: "content-box",
    ref: "content"
};
const _hoisted_5 = { class: "header" };
const _hoisted_6 = ["src"];
const _hoisted_7 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PostsView = _resolveComponent("PostsView");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
            class: "logo-box",
            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.changeHome()))
        }, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                    alt: "default",
                    src: _ctx.imgUrl
                }, null, 8, _hoisted_6)
            ]),
            _createVNode(_component_PostsView, { posts: _ctx.posts }, null, 8, ["posts"])
        ], 512),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: _normalizeClass(["item", 'item' + item.id]),
                onClick: ($event) => (_ctx.changeUrl(index + 1)),
                ref_for: true,
                ref: 'item' + index
            }, [
                _createElementVNode("div", null, _toDisplayString(item.name), 1)
            ], 10, _hoisted_7));
        }), 128))
    ]));
}
